import type { ReactNode } from "react";
import { useInstantSearch } from "react-instantsearch";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { RebrandBadge } from "@tudigo-monorepo/web-tudigo-components";

const SearchProjectsHeaderTitle = ({ children }: { children?: ReactNode }) => {
  const { results } = useInstantSearch();
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-x-4">
      <h1 className="font-roobert text-black-primary text-pretty text-[28px] font-medium">
        {children}
      </h1>
      <RebrandBadge className="font-roobert border-black-500 text-black-primary whitespace-nowrap rounded-full bg-neutral-100 text-xs font-semibold">
        {t("search_projects_page.projects_count", {
          count: results.nbHits,
        })}
      </RebrandBadge>
    </div>
  );
};

const SearchProjectsHeaderContent = ({
  children,
}: {
  children?: ReactNode;
}) => {
  return (
    <div className="flex flex-col justify-between gap-4 md:flex-row">
      {children}
    </div>
  );
};

const SearchProjectsHeader = ({ children }: { children?: ReactNode }) => {
  return (
    <header className="border-black-600 border-b bg-white">
      <div className="container mx-auto flex w-full flex-col gap-y-4 p-4 md:py-6">
        {children}
      </div>
    </header>
  );
};

export {
  SearchProjectsHeader,
  SearchProjectsHeaderContent,
  SearchProjectsHeaderTitle,
};
